export default {
  path: '/subscription-imports',
  name: 'subscription-imports',
  component: () => import(/* webpackChunkName: "imported-subscriptions" */ './ImportedSubscriptions'),
  meta: { requiresAuth: true }
}
